import { addonConstants } from '../Constants';
import { adminUsersServices } from '../Services';
import { editaddonConstants } from "../Constants"

export const addonUserActions = {
    searchAddon,
    EDITAddon
};

function searchAddon(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: addonConstants.SEARCH_ADDON_REQUEST,
            data: null
        }));
        adminUsersServices.searchAddon(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: addonConstants.SEARCH_ADDON_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: addonConstants.SEARCH_ADDON_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: addonConstants.SEARCH_ADDON_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

function EDITAddon(data: any) {
    return (dispatch: any) => {
        dispatch(dispatchFunction({
            type: editaddonConstants.EDIT_ADDON_REQUEST,
            data: null
        }));
        adminUsersServices.editAddon(data)
            .then(
                response => {
                    if (response.status) {
                        dispatch(dispatchFunction({
                            type: editaddonConstants.EDIT_ADDON_SUCCESS,
                            data: response.data
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: editaddonConstants.EDIT_ADDON_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: editaddonConstants.EDIT_ADDON_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}



function dispatchFunction(data: any) {
    // To do: check for refresh / unauthorized error
    return {
        type: data.type,
        data: data.data
    };
}